import { IGameConfiguration } from 'interfaces/gameInterfaces';

const gameConfigurations: IGameConfiguration[] = [
  {
    id: 'game',
    screenSizes: {
      maxDesktopScreen: 768,
      mobileScreen: 480,
      mediumScreen: 420,
      smallScreen: 360
    },
    entry: {
      redirectURL: '/',
      type: 'Redirect',
      loginURL: '/login',
      registrationURL: '/register',
      tokenFromParentType: 'PostMessage',
      tokenCookieName: 'AppSession',
      useDummyLoginButtonInLocalhost: true,
      useDummyLoginButtonInProduction: false
    },
    settings: {
      regions: {
        uk: ['£1,500,000'],
        // ie
        ie: ['€350,000'],
        // ng
        ng: ['₦16,000,000'],
        // nl
        nl: ['€250,000']
      },
      defaultLocale: '',
      languageFromParentType: 'PostMessage',
      languageCodeIdentifier: 'l',
      defaultLanguage: process.env.REACT_APP_LANGUAGE || 'en-gb',
      fallbackLanguage: 'en-gb',
      supportedLanguages: ['en-gb', 'nl', 'bg'],
      poweredByIncentiveLogo: false,
      clickLogoToGoHome: false,
      storageType: 'localStorage',
      defaultCurrency: 'GBP',
      currencyFromParentType: 'PostMessage',
      currencyCodeIdentifier: 'c',
      supportedCurrencies: ['GBP', 'NGN', 'EUR', 'BGN'],
      allowParentChanges: false,
      refreshEventsFrequency: 60000,
      widgetEnabled: true,
      bonusEnabled: false,
      useFullscreenAndroid: true,
      showShirtNumbers: false,
      themeTextColour: '#fff',
      eurosDisplayWindow: [1716159600000, 1720997995000],
      termsAndConditionsDisplayRegions: ['ie', 'uk', 'bg'],
      upsellBannerURL:
        process.env.REACT_APP_UPSELL_URL ||
        (process.env.REACT_APP_REGION === 'nl'
          ? `https://www.livescorebet.com/nl-nl/dl/category?categoryId=SBTC3_188080&view=outrights&source=squads-banner`
          : `https://www.livescorebet.com/${process.env.REACT_APP_REGION}/dl/category?categoryId=SBTC3_188080&view=outrights&source=squads-banner`)
    },
    bonusWheel: {
      rotatePrizeText: true,
      spokesColor: '#333333',
      tickerColor: '#ff8a00',
      prizesConfig: {
        GBP: {
          prizeArray: [
            { value: 50, bgColor: '#FF8A00', textColor: '#FFFFFF' },
            { value: 0.1, bgColor: '#333333', textColor: '#FFFFFF' },
            { value: 1, bgColor: '#4D4D4D', textColor: '#FFFFFF' },
            { value: 5, bgColor: '#5EE8B8', textColor: '#FFFFFF' },
            { value: 20, bgColor: '#23DF8C', textColor: '#FFFFFF' },
            { value: 0.5, bgColor: '#AAAAAA', textColor: '#FFFFFF' },
            { value: 2, bgColor: '#0B0B0B', textColor: '#FFFFFF' },
            { value: 10, bgColor: '#FFB65F', textColor: '#FFFFFF' }
          ],
          prizeOrderArray: [1, 2, 3, 4, 5, 6, 7, 8, 2, 3, 4, 6, 7, 3, 2, 8, 6, 4, 2, 3, 7, 5, 6, 7, 8, 2, 3, 4, 6, 4, 7, 8, 2, 6, 3]
        },
        NGN: {
          prizeArray: [
            { value: 2000, bgColor: '#FF8A00', textColor: '#000000' },
            { value: 50, bgColor: '#333333', textColor: '#FFFFFF' },
            { value: 150, bgColor: '#4D4D4D', textColor: '#FFFFFF' },
            { value: 300, bgColor: '#5EE8B8', textColor: '#000000' },
            { value: 1000, bgColor: '#23DF8C', textColor: '#000000' },
            { value: 100, bgColor: '#AAAAAA', textColor: '#000000' },
            { value: 200, bgColor: '#0B0B0B', textColor: '#FFFFFF' },
            { value: 500, bgColor: '#FFB65F', textColor: '#000000' }
          ],
          prizeOrderArray: [1, 2, 3, 4, 5, 6, 7, 8, 2, 3, 4, 6, 7, 3, 2, 8, 6, 4, 2, 3, 7, 5, 6, 7, 8, 2, 3, 4, 6, 4, 7, 8, 2, 6, 3]
        },
        EUR: {
          prizeArray: [
            { value: 50, bgColor: '#FF8A00', textColor: '#FFFFFF' },
            { value: 0.1, bgColor: '#333333', textColor: '#FFFFFF' },
            { value: 1, bgColor: '#4D4D4D', textColor: '#FFFFFF' },
            { value: 5, bgColor: '#5EE8B8', textColor: '#FFFFFF' },
            { value: 20, bgColor: '#23DF8C', textColor: '#FFFFFF' },
            { value: 0.5, bgColor: '#AAAAAA', textColor: '#FFFFFF' },
            { value: 2, bgColor: '#0B0B0B', textColor: '#FFFFFF' },
            { value: 10, bgColor: '#FFB65F', textColor: '#FFFFFF' }
          ],
          prizeOrderArray: [1, 2, 3, 4, 5, 6, 7, 8, 2, 3, 4, 6, 7, 3, 2, 8, 6, 4, 2, 3, 7, 5, 6, 7, 8, 2, 3, 4, 6, 4, 7, 8, 2, 6, 3]
        },
        BGN: {
          prizeArray: [
            { value: 50, bgColor: '#FF8A00', textColor: '#FFFFFF' },
            { value: 0.1, bgColor: '#333333', textColor: '#FFFFFF' },
            { value: 1, bgColor: '#4D4D4D', textColor: '#FFFFFF' },
            { value: 5, bgColor: '#5EE8B8', textColor: '#FFFFFF' },
            { value: 20, bgColor: '#23DF8C', textColor: '#FFFFFF' },
            { value: 0.5, bgColor: '#AAAAAA', textColor: '#FFFFFF' },
            { value: 2, bgColor: '#0B0B0B', textColor: '#FFFFFF' },
            { value: 10, bgColor: '#FFB65F', textColor: '#FFFFFF' }
          ],
          prizeOrderArray: [1, 2, 3, 4, 5, 6, 7, 8, 2, 3, 4, 6, 7, 3, 2, 8, 6, 4, 2, 3, 7, 5, 6, 7, 8, 2, 3, 4, 6, 4, 7, 8, 2, 6, 3]
        }
      }
    }
  }
];

export default gameConfigurations[0];
